import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowRight2px, Sizes } from "@/components/icon/IconList";
import { MYPAGE_PASSES } from "@/settings/constant";
import { ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { useRouter } from "next/router";
const ManagePassLink = ()=>{
    const theme = useTheme();
    const router = useRouter();
    const handleClick = ()=>{
        router.push(MYPAGE_PASSES);
    };
    return /*#__PURE__*/ _jsx(ButtonBase, {
        disableRipple: true,
        sx: {
            width: "100%",
            py: 1.5,
            px: 2
        },
        onClick: handleClick,
        children: /*#__PURE__*/ _jsxs(Stack, {
            sx: {
                width: "100%",
                flexDirection: "row",
                gap: 0.5,
                alignItems: "center",
                justifyContent: "center"
            },
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle2",
                    sx: {
                        color: "primary.main"
                    },
                    children: "이용권 관리 가기"
                }),
                /*#__PURE__*/ _jsx(ArrowRight2px, {
                    size: Sizes.small,
                    color: theme.palette.primary.main
                })
            ]
        })
    });
};
export default ManagePassLink;
